export interface IReservationTabBadge {
  count: number;
  color: 'warning' | 'neutral';
  titleKey?: string;
}

export interface IReservationTab {
  id: string;
  icon: string;
  badge?: IReservationTabBadge;
}

export function reservationTabs(options: {
  canManage: boolean;
  canSettings: boolean;
  pendingCount: number;
  waitingCount: number;
}): IReservationTab[] {
  return [
    ...(options.canManage
      ? [
          { id: 'today', icon: 'calendar-today' },
          {
            id: 'agenda',
            icon: 'calendar-month-outline',
            // Pending requests may be weeks away; the agenda lists them all.
            ...(options.pendingCount > 0
              ? {
                  badge: {
                    count: options.pendingCount,
                    color: 'warning' as const,
                    titleKey: 'reservations.tabs.pendingBadge',
                  },
                }
              : {}),
          },
          {
            id: 'waitlist',
            icon: 'clipboard-list-outline',
            ...(options.waitingCount > 0
              ? {
                  badge: {
                    count: options.waitingCount,
                    color: 'neutral' as const,
                  },
                }
              : {}),
          },
          { id: 'guests', icon: 'account-group-outline' },
          { id: 'reports', icon: 'chart-bar' },
        ]
      : []),
    ...(options.canSettings ? [{ id: 'settings', icon: 'cog-outline' }] : []),
  ];
}
